var _rect, _rect2, _text, _text2, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 600,
    viewBox: "0 0 300 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#2a2a2a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 280,
    height: 580,
    fill: "none",
    stroke: "#444",
    strokeWidth: 2,
    strokeDasharray: "10,5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 270,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#666",
    textAnchor: "middle"
  }, "MISSING")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 310,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#666",
    textAnchor: "middle"
  }, "PREVIEW")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 360,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#555",
    textAnchor: "middle"
  }, "(Mobile Image)")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 400,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#444",
    textAnchor: "middle"
  }, "DEV MODE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderMobile);
export default __webpack_public_path__ + "static/media/placeholder-mobile.35b2256fa7c6ddf83f2e7d8924e1ac20.svg";
export { ForwardRef as ReactComponent };